module.exports = __webpack_public_path__ + "img/temp-blog-04.24a62b01.jpg";